export const SELECTED_ACCOUNT_LOCAL_STORAGE_KEY = 'selectedAccount';
